export default __webpack_public_path__ + "static/media/checkYellow.755fec31.svg";